export default __webpack_public_path__ + "media/images/mexico/img5.png";